import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id EE80C9C6-6C17-4049-9C87-B6E7E3D956EA
 * name folder-swap-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-swap-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderSwapOutlineIcon = createSvgIcon(<><path d="M20 18H4V8H20M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M18 13L15 10V12H9V10L6 13L9 16V14H15V16Z" /></>, 'FolderSwapOutlineIcon');
export default FolderSwapOutlineIcon